import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Lock.svg'

export const IconLock = IconSVG as IconComponent
